export default {
  path: '/third_party_verifiers',
  name: 'third_party_verifier_base',
  component: () => import('@/views/third_party_verifier/Base.vue'),
  children: [
    {
      path: ':id/authorize',
      name: 'third_party_verifier_authorize',
      component: () => import('@/views/third_party_verifier/Authorize.vue'),
    },
    {
      path: 'success',
      name: 'third_party_verifier_success',
      component: () => import('@/views/third_party_verifier/Success.vue'),
    },
    {
      path: 'discard',
      name: 'third_party_verifier_discard',
      component: () => import('@/views/third_party_verifier/Discard.vue'),
    },
    {
      path: ':id/reports/:reportId',
      name: 'third_party_verifier_view_report',
      component: () => import('@/views/third_party_verifier/ViewReport.vue'),
    },
  ],
}
